<div class="full-width">
  <div class="brand-ppbody">
    <app-nav-bar class="brand-ppbody__navbar"></app-nav-bar>
    <main class="brand-ppbody__main">
      <router-outlet></router-outlet>
    </main>
    <app-footer class=" brand-ppbody__navbar"> </app-footer>
  </div>
</div>
